// extracted by mini-css-extract-plugin
module.exports = {"outer-wrapper":"styles_outer-wrapper__eB5XP","inner-wrapper":"styles_inner-wrapper__7GGGX"};